import { AboutPageOneComponent } from './common/about-page-one/about-page-one.component';
import { ComingSoonPageComponent } from './common/coming-soon-page/coming-soon-page.component';
import { LoginPageComponent } from './auth/login-page/login-page.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactListComponent } from './common/contact-list/contact-list.component';
import { HomePageComponent } from './home-page/home-page.component';

const routes: Routes = [
  {
    path: '',
    component: HomePageComponent
  },
  {
    path: 'student/:auth',
    component: LoginPageComponent
  },
  {
    path: 'about-us',
    component: AboutPageOneComponent
  },
  {
    path: 'contacts',
    component: ContactListComponent
  },
  {
    path: 'coming-soon',
    component: ComingSoonPageComponent
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
